import {
    faDatabase,
    faEnvelope,
    faFolder,
    faTable,
    faTableColumns,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { RepoType } from '../constants/repoType';

export const getRepoIcon = (repoInfo) => {
    if (!repoInfo || !repoInfo.repotype) {
        return faFolder;
    }
    if (repoInfo.storage_type === RepoType.EXTRACTED_DB) return faTableColumns;
    if (repoInfo.storage_type === RepoType.AUTO_DB) return faTable;
    if (repoInfo.repotype === RepoType.TABULAR) return faTable;
    if (
        [RepoType.SQLLITE, RepoType.POSTGRESS, RepoType.MSSQL].includes(
            repoInfo.repotype
        )
    )
        return faDatabase;
    if (repoInfo.repotype === RepoType.GLOBAL) return faFolder;
    if (repoInfo.repotype === RepoType.MASTER_AGENT) return faUsers;
    if (!repoInfo.storage_type) {
        return faFolder;
    }
    if (repoInfo.storage_type === RepoType.EMAIL) return faEnvelope;

    return faFolder;
};
